import { render, staticRenderFns } from "./ArchivesSearch.vue?vue&type=template&id=c078f546"
import script from "./ArchivesSearch.vue?vue&type=script&lang=js"
export * from "./ArchivesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports